module.exports = __webpack_public_path__ + "static/media/copy.0ce4ceaa.svg";